import getIsTWAMode from './appMode_helper'
import { isDiscoveryCodeVersionSupported } from './discoveryCodeGate'

/**
 * Asks the native app to clear the Discovery Code notification. No-op outside the TWA.
 *
 * Deliberately NOT gated on the feature flag: flipping the kill switch off must not strand a notification
 * (a live credential) that is already posted.
 */
export default function clearDiscoveryCodeNotification() {
  if (typeof window === 'undefined' || !getIsTWAMode() || !isDiscoveryCodeVersionSupported()) return
  window.location.href = 'togetherscheme://clear-discovery-code'
}
